var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0375 9.41594L55.0181 54.9577L80.7942 16.3442L55.0333 54.9679L93.6238 29.1576L55.0433 54.9829L100.574 45.9053L55.047 55.0008L100.585 64.0378L55.0435 55.0185L93.657 80.7946L55.0333 55.0336L80.8436 93.6242L55.0183 55.0437L64.096 100.574L55.0004 55.0474L45.9634 100.586L54.9827 55.0439L29.2066 93.6573L54.9676 55.0336L16.377 80.8439L54.9575 55.0186L9.42718 64.0963L54.9538 55.0007L9.4156 45.9637L54.9573 54.9831L16.3439 29.207L54.9676 54.9679L29.1573 16.3773L54.9826 54.9579L45.9049 9.42753L55.0005 54.9542L64.0375 9.41594Z",
    stroke: "#E3E3E3",
    strokeWidth: 5.24685
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_101_3051",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0999 8.19961C42.7143 8.19961 30.836 13.1198 22.078 21.8777C13.3201 30.6357 8.3999 42.514 8.3999 54.8996C8.3999 67.2852 13.3201 79.1635 22.078 87.9215C30.836 96.6794 42.7143 101.6 55.0999 101.6L55.0999 54.8996L55.0999 8.19961Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0999 8.19961C42.7143 8.19961 30.836 13.1198 22.078 21.8777C13.3201 30.6357 8.3999 42.514 8.3999 54.8996C8.3999 67.2852 13.3201 79.1635 22.078 87.9215C30.836 96.6794 42.7143 101.6 55.0999 101.6L55.0999 54.8996L55.0999 8.19961Z",
    fill: "#C0B6F2",
    stroke: "#C0B6F2",
    strokeWidth: 0.749679,
    mask: "url(#path-2-inside-1_101_3051)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.bbf86943b98f4e38714188532b601c39.svg";
export { ForwardRef as ReactComponent };